module.exports = __webpack_public_path__ + "img/abdominal.fdf3c95a.png";